import { css } from 'linaria';

const brandLinkItemGap = 'var(--space-300)';
const otherProductsImageWrapperWidth = 64;
const otherProductsImageWrapperHeight = 64;

export const brandLinkItem = css`
  justify-content: flex-start;
  gap: var(--space-200);
  padding: var(--space-75) 0;
  width: 100%;
`;

export const otherProductsImageWrapper = css`
  width: ${otherProductsImageWrapperWidth}px;
  height: ${otherProductsImageWrapperHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--rounding-m);
  overflow: hidden;
  position: relative;
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--background-accent);
    opacity: 0.05;
  }
`;

export const brandLinkWrapper = css`
  display: flex;
  flex-direction: column;
  column-gap: ${brandLinkItemGap};

  @media (--from-desktop) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const title = css`
  margin-bottom: var(--space-150);
`;

export const otherProductsSection = css`
  @media (--to-tablet) {
    padding: var(--space-200);
  }
`;

export const imageFallback = css`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

export const brandWord = css`
  display: inline-flex;
  width: 28px;
  height: 30px;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: var(--rounding-m);
  overflow: hidden;
`;

export const image = css`
  width: 48px;
  height: 48px;
`;

export const brandLinkContainer = css`
  position: relative;

  @media (--from-desktop) {
    flex: 0 0 calc(50% - ${brandLinkItemGap} / 2);
  }
`;

export const brandWordAbsolute = css`
  position: absolute;
  top: ${(otherProductsImageWrapperHeight + 12) / 2}px;
  left: ${otherProductsImageWrapperHeight / 2}px;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
`;
